import type { ReactNode } from "react";
import type { PermitStep } from "@/lib/permitProcesses";

export function CaseCard({ title, children }: { title: string; children: ReactNode }) {
  return <section className="min-w-0 space-y-3 rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] p-4"><h2 className="text-lg font-semibold">{title}</h2>{children}</section>;
}

export function ProcessProgress({ steps }: { steps: PermitStep[] }) {
  const sorted = [...steps].sort((a, b) => a.sequence - b.sequence);
  const next = sorted.find(step => ["pending", "in_progress"].includes(step.status));
  return <ol aria-label="Koraci postupka" className="flex flex-wrap gap-3 text-sm">{sorted.map(step => <li key={step.id} aria-current={step.id === next?.id ? "step" : undefined} className={step.id === next?.id ? "font-semibold" : ""}>{step.status === "completed" ? "✓ " : step.id === next?.id ? "Sljedeće: " : ""}{step.name_hr}</li>)}</ol>;
}
